var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { className: "grid-view" } }, [
    _c("div", { attrs: { className: "main-content" } }, [
      _c(
        "div",
        { attrs: { className: "section grid-wrapper" } },
        [
          _c("cargo-ag-grid", {
            attrs: {
              "config-module": _vm.configModule,
              "grid-params": _vm.gridParams,
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.rowData
            },
            on: {
              "update:gridParams": function($event) {
                _vm.gridParams = $event
              },
              "update:grid-params": function($event) {
                _vm.gridParams = $event
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { attrs: { className: "pagination-wrapper" } },
        [
          _c("cargo-pagination", {
            attrs: {
              "config-module": _vm.configModule,
              total: _vm.rowData.length,
              page: _vm.filter.pageNum,
              limit: _vm.filter.pageSize,
              layout: "total, slot"
            },
            on: {
              "update:page": function($event) {
                return _vm.$set(_vm.filter, "pageNum", $event)
              },
              "update:limit": function($event) {
                return _vm.$set(_vm.filter, "pageSize", $event)
              },
              pagination: function($event) {
                return _vm.toQuery()
              }
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }